// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { PagePdfAccessibilityService } from '@client/app/services/entities/pdf-accessibility/page-pdf-accessibility.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'document-details-dashboard-accessibility',
    standalone: false,
    template: `
        <div class="row align-items-center">
            <div class="offset-4 col-18 page-dashboard-doughnut-container">
                <mon-chart-doughnut [labels]="labels"
                                [data]="data"
                                [options]="options"
                                [colors]="colors">
                </mon-chart-doughnut>
            </div>
            <div class="col-26">
                <notification-change title="{{ 'Accessibility issues' | translate }}"
                                     [digit]="getChecksInErrorCount()">
                    <div class="mt-3"
                         translate
                         [translate-args]="{issues: getErrorCount() | monNumber}">
                        (<strong>[[issues]]</strong> unique problems)
                    </div>
                </notification-change>
            </div>
        </div>
    `,
})
export class DocumentDetailsDashboardAccessibilityComponent implements OnInit {
    @Input() document: any;

    checks: any[] = [];
    colors: string[] = ['#4dc0bd', '#dcdcdc'];
    options: any = {};
    data: any[] = [];
    labels: string[] = ['', ''];
    totalChecksCount: number = 0;

    constructor (
        private pagePdfAccessibilityService: PagePdfAccessibilityService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.checks = [];
        this.colors = ['#4dc0bd', '#dcdcdc'];
        this.options = {};
        this.data = [];
        this.labels = ['', ''];
        this.getChecks().then((checks: any[]) => {
            this.totalChecksCount = checks.length;
            this.checks = checks;
            this.setupDoughnut();
        }).catch(() => {
            // Error handling - equivalent to angular.noop
        });
    }

    private getChecks (): Promise<any[]> {
        return this.pagePdfAccessibilityService.getAllChecks(this.document.id, undefined);
    }

    getChecksInErrorCount (): number {
        return this.checks.reduce((sum: number, check: any) => {
            if (check.errors_count > 0) {
                sum++;
            }
            return sum;
        }, 0);
    }

    getErrorCount (): number {
        return this.checks.reduce((sum: number, check: any) => {
            if (check.errors_count > 0) {
                sum += parseInt(check.errors_count);
            }
            return sum;
        }, 0);
    }

    private setupDoughnut (): void {
        const checkErrorCount = this.getChecksInErrorCount();

        this.data = [this.totalChecksCount - checkErrorCount, checkErrorCount];
        const percentage = (checkErrorCount / this.totalChecksCount) * 100;
        this.options = {
            centerText: {
                percentageLabel: this.pipeService.get('monNumber')((100 - percentage) / 100, '0.[00] %'),
            },
            cutoutPercentage: 80,
            tooltips: {
                enabled: checkErrorCount > 0,
                callbacks: {
                    beforeLabel: (tooltipItem: any, data: any) => {
                        return '';
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(
                            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                            '0,0',
                        );
                    },
                },
            },
        };
    }
}
